import { ChangelogVersionSummary, FormattedChangelog } from '@lfp-digital/back-types-mpg';
import {orderBy} from 'lodash';
import React, {
  CSSProperties,
  useEffect,
  useState,
} from 'react';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {getEndpoint, getHeaders, getMPPEndpoint} from '../../../helpers/endpoint';
import moment from 'moment';

const Styles: Record<string, CSSProperties> = {
  container: {
    margin: 16,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
    backgroundColor: 'white',
  },
  item: {
    verticalAlign: 'middle',
  }
};

const getChangelog = (
  isMPP: boolean,
  onSuccess: (response: FormattedChangelog) => void,
) => {
  return (_dispatch, getState) => {
    return fetch((isMPP ? getMPPEndpoint : getEndpoint)('getChangelog'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          onSuccess(data);
        }
      })
      .catch(() => {});
  };
};

const deleteVersion = (
  isMPP: boolean,
  version: string,
  onSuccess: (data: FormattedChangelog) => void,
) => {
  return (_dispatch, getState) => {
    return fetch((isMPP ? getMPPEndpoint : getEndpoint)('version', version), {
      method: 'DELETE',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          // eslint-disable-next-line no-unused-expressions
          onSuccess?.(data);
        }
      })
      .catch(() => {});
  };
};

type OrderType = {type: string; sort: 'asc' | 'desc'};

const orderList = (
  data: ChangelogVersionSummary[],
  order: OrderType,
) => orderBy(data, [order.type], [order.sort]);

export const VersionsList = ({ history, match }) => {
  const dispatch = useDispatch();
  const isMPP = match?.path?.includes('mpp');

  const [order, setOrder] = useState<OrderType>({
    type: 'name',
    sort: 'desc',
  });

  const [versions, setVersions] = useState<ChangelogVersionSummary[]>();

  useEffect(() => {
    dispatch(
      getChangelog(isMPP, (response) =>
        setVersions(
          orderList(response.versions, order),
        ),
      ),
    );
  }, []);

  useEffect(() => {
    if (versions) {
      setVersions(
        orderList(versions, order),
      );
    }
  }, [order]);

  const setOrderForNotif = (type: string) => {
    setOrder(state => {
      return {
        type,
        sort:
          state.type === type
            ? state.sort === 'asc'
              ? 'desc'
              : 'asc'
            : state.sort,
      };
    });
  };

  return (
    <div style={Styles.container}>
      {versions?.length ? (
        <table className="table table-responsive table-striped text-center align-middle">
          <thead>
            <tr>
              <th
                onClick={() => setOrderForNotif('version')}
                style={{cursor: 'pointer'}}>
                Version
              </th>
              <th
                onClick={() => setOrderForNotif('name')}
                style={{cursor: 'pointer'}}>
                Name
              </th>
              <th
                onClick={() => setOrderForNotif('versionDate')}
                style={{cursor: 'pointer'}}>
                Date
              </th>
              <th style={{cursor: 'pointer'}}>Tags</th>
              <th
                onClick={() => setOrderForNotif('status')}
                style={{cursor: 'pointer'}}>
                Status
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {versions?.map(item => {
              return (
                <tr key={item.id}>
                  <th style={Styles.item}>{item?.version}</th>
                  <th style={Styles.item}>{item?.name}</th>
                  <th style={Styles.item}>{moment(item?.versionDate).format('DD/MM/YYYY') || '-'}</th>
                  <th style={Styles.item}>{item?.tags?.join(', ') || '-'}</th>
                  <th style={Styles.item}>{item?.status || '-'}</th>
                  <th style={Styles.item}>
                    <button
                      style={{marginRight: 8}}
                      className="btn"
                      onClick={() =>
                        history.push(isMPP ? `/mpp/version/update/${item.version}` : `/version/update/${item.version}`)
                      }>
                      Modifier
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        swal({
                          title: 'Are you sure ?',
                          type: 'info',
                          showCloseButton: true,
                          showCancelButton: true,
                          focusConfirm: false,
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        }).then(() => {
                          if (item.version) {
                            dispatch(
                              deleteVersion(isMPP, item.version, (response) =>
                                setVersions(response?.versions),
                              ),
                            );
                          }
                        });
                      }}>
                      <i style={{color: 'white'}} className="fa fa-trash" />
                    </button>
                  </th>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
          <div style={{textAlign: 'center', fontSize: 24}}>No versions found!</div>
          <button className="btn btn-primary btn-flat m-4" onClick={() => history.push('/version/create')}>
            Create version
          </button>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Versions/List/index.tsx